import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    position: "absolute",
    top: theme.spacing(8),
    right: theme.spacing(3),
    zIndex: 9999,
  },
  alert: {
    width: "100%",
    marginTop: theme.spacing(4),
  },
  alertContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: theme.spacing(4),
    paddingRight: theme.spacing(6),
    backgroundColor: theme.palette.background.paper,
    fontSize: "0.75rem",
    borderRadius: "0.375rem",
    border: "1px solid #E2E8F0",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px   -2px rgba(0, 0, 0, 0.05)",
  },
  closeButton: {
    display: "none",
    cursor: "pointer",
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),

    "&:hover": {
      color: theme.palette.secondary.main,
    },
  },
  show: {
    display: "block",
  },
}));
